import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7730957e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-check-box" }
const _hoisted_2 = ["name", "disabled", "required"]
const _hoisted_3 = { key: 0 }

import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-check-box',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _withDirectives(_createElementVNode("input", {
        name: _ctx.description.name,
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description.ivalue) = $event)),
        disabled: _ctx.description.disabled,
        required: !!_ctx.description.frontend_only
      }, null, 8, _hoisted_2), [
        [_vModelCheckbox, _ctx.description.ivalue]
      ]),
      (_ctx.description.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.description.label), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})